<template>
  <div id="app">
    <template v-if="isMobile && support">
      <Stream
        @support="handleSupport"
        @success="handleSuccessReading"
      />
    </template>
    <div
      v-if="!isMobile || !support"
      class="container"
    >
      <div class="container__error">{{!support ? 'Try to use another browser (Safari preferable)' : 'Please enter from mobile device'}}</div>
    </div>
  </div>
</template>

<script>
import Stream from '@/components/Stream'

export default {
  name: 'App',
  components: {
    Stream
  },
  data: () => ({
    support: true,
    isMobile: (() => {
      const agent = navigator.userAgent || navigator.vendor || window.opera
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test((agent).substr(0,4))
    })()
  }),
  methods: {
    handleSuccessReading (url) {
      window.location = url
      // const win = window.open(url)
      // win.focus()
    },
    handleSupport (state) {
      this.support = state
    }
  }
}
</script>

<style lang="scss">
@import './styles/reset';
@import './styles/common';

html,
body,
#app {
  height: 100%;
}

.container {
  // -webkit-overflow-scrolling: touch;
  // overflow: auto;
  // height: calc(100% - 70px);

  &__intro {
    padding: 50px 0 0;
    text-align: center;
  }

  &__placeholder {
    margin: 80px auto 0;
  }

  &__error {
    margin-top: 20px;
    color: red;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  &__iframe {
    margin-bottom: 70px;
    width: 100%;
    // min-height: 100%;
  }
}

.toolbar {
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: 10px;
  height: 50px;
  font-size: 0;
  text-align: center;

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity .5s, transform 0.5s;
  }
  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
</style>
